import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import { Table } from '../components/CommonTable';
import { DragSourceAndDropTarget } from '../components/DnDWrapper';
import { UserTypeSwitchForm } from '../components/UserTypeSwitchForm';
import PrimeContractorToPartnerButton from '../components/button/PrimeContractorToPartnerButton';
import {
  CORPORATE_ADMINISTRATOR_MANUAL,
  USER_ROLES,
  HEADER_CONSTANTS,
  REQUEST_PARAMS,
  USER_STATUS,
  CHECKBOX,
} from '../utilities/constants';
import { createLocalEventManager } from '../utilities/EventManager';
import fetchMg from '../utilities/fetchManager';
import PrintUtility from '../utilities/printUtility';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import {
  isTargetRoleId,
  isPrimaryCompanyRoleId,
  isLoginUserPartner,
  isLoginUserForeman,
  isLoginUserManager,
  getRoleNameByRoleId,
  isPartnerRoleId,
  isPartnerCompanyRoleId,
  isForemanRoleId,
} from '../utilities/roleUtility';
import { getSortButton } from '../utilities/sortUtility';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { UserService } from '../services/Users';
import UsersApi from '../services/users/UsersApi';
import UsersService from '../services/users/UsersService';
import BuildeeManagerRequestApi from '../services/buildeeManagerRequest/BuildeeManagerRequestApi';
import dialogLoader from '../utilities/dialogLoader';
import ForemanNewPasswordDialog, {
  DialogType,
} from '../components/dialogs/ForemanNewPasswordDialog';
import { messageUtility } from '../utilities/messageUtility';
import { CompanyBranchDropdown } from '../components/dropdowns/single/CompanyBranch';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from '../components/PartnerCompanyBranchDropdown';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import { csvDownloader } from '../utilities/commonUtil';
import Tippy from '../components/ReactTippy';
import { MasterPageHeader } from '../components/PageHeader';
import Information from '../components/modals/common/Information';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { BuildeeManagerIcon } from '../components/icons/BuildeeManagerIcon';
import Styles from '../styles/componentStyle/entrance/Users.scss';
import { setCompanyBranchNameForGTM } from '../utilities/gtm';
import { UpdatePartnerCompanyBranchUsersDialog } from '../components/modals/UpdatePartnerCompanyBranchUsersDialog';
import { BuildeeManagerApplyingModal } from '../components/modals/BuildeeManagerApplyingModal';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';

const MY_EVENT = {
  CHANGE_FORM_SHOW: 'change_form_show', // 編集フォームの表示イベント
  SEARCH_FORM_CHANGE: 'search_form_change', // 検索項目変更イベント
};

const EventMg = createLocalEventManager(MY_EVENT);
const ENUM_DIALOG = {
  noSelectUser: 1,
  updatePartnerCompanyBranch: 2,
  updateSuccess: 3,
  updateError: 4,
};

/**
 * @description ユーザー一覧画面
 */
export class Users extends React.Component {
  constructor(props) {
    super(props);

    this.defaultParams = {
      offset: 0,
      limit: REQUEST_PARAMS.parentLimit,
      company_id: SessionStorageService.getCompanyId(),
      order: '',
      company_branch_id: null, // 支店ID検索
      fullname: null, // 氏名検索
      user_id: null, // ユーザーID、メールアドレス検索
      user_role_code: [], // 種別(ロール)検索
      buildee_manager_flg: null, // 企業管理者検索
      block_flag: [USER_STATUS.use.id, USER_STATUS.stop.id], // ステータス検索
    };

    this.state = {
      params: _.cloneDeep(this.defaultParams), // 検索条件（実際にAPIに投げるのはこちら CSV出力用に表示用と投げるためのパラメータを別々に保持している）
      tempParams: _.cloneDeep(this.defaultParams), // 検索条件(保管用、表示に利用する）
      company_branch_id: null,
      search_form_open: true, // search_form の開閉
      searchParam: {
        // 支店検索用
        company_branch_id: null,
        name: '',
        clearFlag: false,
      },
      isFetch: false,
      isLoading: true,
      isNewSearch: false, // 検索ボタン押下時のフラグ(BLDE_V2-41384)
      isActiveChangePermissionButton: false,
      isActiveManagerRequestButton: false,
      isViewManagerRequestButton: false,
      errorDialogFlg: false,
      errorMessage: '',
      buildeeManagerGrantRequest: null,
      buildeeManagerMessageFlg: false,
      partnerCompanyBranchId: null,
      userSelected: [],
      selectAll: false,
      dialogType: null,
      dialogInfo: { title: '', message: '' },
      isBuildeeManager: false,
      visibleDownloadErrorDialog: false,
    };

    this.handleClearParam = this.handleClearParam.bind(this);

    this.events = {
      form: {
        dropdownParam: this.setDropdownParam,
      },
    };

    this.total = 0; // 検索結果件数を保持

    this.companyId = SessionStorageService.getCompanyId(); // 会社ID
    this.userId = LocalStorageService.getUserId(); // ユーザーID
    this.roleId = LocalStorageService.getRoleId(); // ロールID
    this.companyBranchId = parseInt(
      SessionStorageService.getItem('company_branch_id'),
      10
    ); // 支店ID
    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();

    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.searchingFlag = false;

    this.firstLoadFlg = false; // 初回API実行フラグ

    this.callbacks = [
      {
        // 編集ボタンを押したときの処理
        type: MY_EVENT.CHANGE_FORM_SHOW,
        callback: user => {
          // 別ブラウザからログインユーザーの支店IDが変更された場合、
          // 利用者詳細画面のアカウント停止処理で不具合が起きるので、
          // APIから最新の支店IDを取得し、SessionStorageに設定
          if (
            isTargetRoleId(
              [USER_ROLES.branch, USER_ROLES.manager],
              this.role_id
            )
          ) {
            const userId = LocalStorageService.getUserId();
            UserService.show(userId).then(response => {
              if (response.result === true) {
                const companyBranchId =
                  response.data.entities.user.company_branch[0].id;
                SessionStorageService.setCompanyBranchId(companyBranchId);

                setCompanyBranchNameForGTM(
                  _.get(
                    response,
                    'data.entities.user.company_branch[0].name',
                    ''
                  )
                );

                _masterSlideLoader.show('UserDetail', {
                  state: { id: user.id },
                });
              }
            });
          } else {
            _masterSlideLoader.show('UserDetail', {
              state: { id: user.id },
            });
          }
        },
      },
      {
        // 検索フォームの変更イベントuser_role_code
        type: MY_EVENT.SEARCH_FORM_CHANGE,
        callback: (val, key, isFetch) => {
          const params = { ...this.state.params };
          if (!_.has(params, key)) {
            params.offset = 'new';
          }
          params[key] = val;
          if (isFetch) {
            this.setState({
              userSelected: [],
              selectAll: false,
              params,
              isFetch,
              isLoading: true,
            });
          } else {
            const tempParams = { ...this.state.tempParams };
            switch (key) {
              case 'user_role_code':
                if (tempParams.user_role_code.includes(val)) {
                  _.remove(tempParams.user_role_code, roleCode => {
                    return roleCode === val;
                  });
                } else {
                  tempParams.user_role_code.push(val);
                }
                break;
              case 'buildee_manager_flg':
                // true→falseにすると、チェックを外した場合に企業管理者ではないユーザーのみを検索してしまうため
                // nullを設定する必要がある。
                tempParams.buildee_manager_flg = tempParams.buildee_manager_flg
                  ? null
                  : true;
                break;
              case 'block_flag':
                if (tempParams.block_flag.includes(val)) {
                  _.remove(tempParams.block_flag, block_flag => {
                    return block_flag === val;
                  });
                } else {
                  tempParams.block_flag.push(val);
                }
                break;
              default:
                tempParams[key] = val;
                break;
            }
            this.setState({ tempParams, isFetch });
          }
        },
      },
    ];

    // イベントにコールバックを設定
    _.each(this.callbacks, val =>
      EventMg.addEventListener(val.type, val.callback)
    );

    this.isUpdatingFlag = false;
    this.isDownloadingFlag = false;
  }

  componentDidMount() {
    this.settingChangePermitButton();
  }

  componentDidUpdate() {
    if (this.state.searchParam.clearFlag === true) {
      this.setState({
        searchParam: {
          clearFlag: false,
        },
      });
    }
  }

  componentWillUnmount() {
    // 追加したイベントを削除
    _.each(this.callbacks, val => {
      EventMg.removeEventListener(val.type, val.callback);
    });
  }

  setDropdownParam = (id, ids) => {
    let params = this.state.params;
    params.company_branch_id = ids;
    const param = _.assign({}, this.state.tempParams, { [id]: ids });
    this.setState({
      tempParams: param,
      params,
    });
  };

  /**
   * @description table itemのデータを追加ロードする
   * @param {Array|Any} list_data 取得したデータ一覧
   */
  userItemLoad = async list_data => {
    let params = _.clone(this.state.params);

    if (params.offset === 'new') {
      params.offset = 0;
    } else if (_.isArray(list_data)) {
      params.offset = list_data.length;
    }

    params = this.changeSortParams(params);

    const sessionPrimeCompanyId = SessionStorageService.getItem(
      'sessionPrimeCompanyId'
    );
    if (isLoginUserPartner() && sessionPrimeCompanyId) {
      params.prime_company_id = sessionPrimeCompanyId;
    }

    const data = await fetchMg
      .GetAjax('/api/private/users/list', params)
      .catch(() => ({ result: false }));
    this.searchingFlag = false;
    this.setState({ isFetch: false, isLoading: false, isNewSearch: false });

    if (data.result) {
      this.total = data.data.total; // 検索結果件数を取得

      // ソート用パラメータ修正
      if (_.has(params, 'sort_company_name')) {
        params.order = `company_${params.sort_company_name}`;
        delete params.sort_company_name;
      }
      if (_.has(params, 'sort_branch_name')) {
        params.order = `branch_${params.sort_branch_name}`;
        delete params.sort_branch_name;
      }
      if (_.has(params, 'sort_fullname')) {
        params.order = `fullname_${params.sort_fullname}`;
        delete params.sort_fullname;
      }
      if (_.has(params, 'sort_fullname_kana')) {
        params.order = `fullname_kana_${params.sort_fullname_kana}`;
        delete params.sort_fullname_kana;
      }
      if (_.has(params, 'sort_user_role_code')) {
        params.order = `user_role_code_${params.sort_user_role_code}`;
        delete params.sort_user_role_code;
      }
      if (_.has(params, 'sort_partner_company_branch_name')) {
        params.order = `partner_company_branch_name_${params.sort_partner_company_branch_name}`;
        delete params.sort_partner_company_branch_name;
      }

      if (this.searchButtonRef.current) {
        this.searchButtonRef.current.disabled = false;
      }
      this.setState({ params });
      return data.data.entities.user_lists || [];
    }

    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = false;
    }
    return [];
  };

  /**
   *
   * @description 管理者権限関連ボタンの表示制御
   * サービス一括変更ボタンは企業管理者の場合のみ活性化
   * 管理者申請ボタンは、一人も企業管理者がいない場合にのみ表示
   * 申請中の企業管理者がいる場合はグレー表示、申請中ユーザーもいなければブルー表示となる
   */
  settingChangePermitButton = async () => {
    const showErrorMessage = res => {
      let errorMessage = '';
      if (res.message) {
        errorMessage = res.message;
      } else {
        errorMessage = res.data.message;
      }
      this.setState({ errorDialogFlg: true, errorMessage });
    };

    if (isLoginUserForeman() || isLoginUserManager()) {
      // 職長と現場監督はサービス一括変更も管理者申請も不可
      this.setState({
        buildeeManagerGrantRequest: null,
        isViewManagerRequestButton: false,
        isActiveManagerRequestButton: false,
      });
      return;
    }

    // 企業管理者を取得
    const response = await UsersApi.fetchCompanyUserPermissions(
      this.companyId,
      {
        buildee_manager_flg: 1,
      }
    );

    if (response.result) {
      if (response.data.total === 0) {
        if (
          isTargetRoleId([USER_ROLES.prime, USER_ROLES.partner], this.roleId)
        ) {
          // 企業管理者がいない場合かつ、本社管理者/協力会社管理者の場合は管理者申請ボタンを表示
          const isViewManagerRequestButton = true;
          let isActiveManagerRequestButton = true;
          let buildeeManagerGrantRequest = null;
          // 企業管理者の申請状況を取得
          const reqResponse = await BuildeeManagerRequestApi.fetchBuildeeBanagerGrantRequests(
            this.companyId,
            isLoginUserPartner() ? this.companyBranchId : 0
          );
          if (reqResponse.result) {
            if (reqResponse.data.total > 0) {
              // 申請がある場合、却下や承認がされていない申請があるかを確認
              // 却下や承認がされていない申請があれば申請ボタンを非活性（グレー）化し申請情報を保持する
              for (let req of reqResponse.data.entities
                .buildee_manager_grant_requests) {
                if (_.isNil(req.approval_flg)) {
                  isActiveManagerRequestButton = false;
                  buildeeManagerGrantRequest = req;
                  break;
                }
              }
            }
          } else {
            showErrorMessage(reqResponse);
          }
          this.setState({
            isViewManagerRequestButton,
            isActiveManagerRequestButton,
            buildeeManagerGrantRequest,
          });
        }
      } else {
        // 企業管理者がおり、その管理者が自身の場合はサービス一括変更ボタンを活性化
        let isActiveChangePermissionButton = false;
        const companyUserPermissions =
          response.data.entities.company_user_permissions;
        let isBuildeeManager = false;
        for (let permission of companyUserPermissions) {
          if (permission.user_id === Number(this.userId)) {
            isActiveChangePermissionButton = true;
            if (isPartnerRoleId(this.roleId)) {
              isBuildeeManager = true;
            }
            break;
          }
        }
        this.setState({ isActiveChangePermissionButton, isBuildeeManager });
      }
    } else {
      showErrorMessage(response);
    }
  };

  /**
   * @description 検索実行
   */
  searchExecution = () => {
    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = true;
    }

    const tempParams = { ...this.state.tempParams, offset: 0 };
    delete tempParams.order;
    const params = { ...this.state.params, ...tempParams };
    const searchParams = { ...this.state.searchParam };
    const { partnerCompanyBranchId } = this.state;

    if (partnerCompanyBranchId) {
      params.partner_company_branch_id =
        partnerCompanyBranchId === HEAD_OFFICE_OPTION.id
          ? null
          : partnerCompanyBranchId;
    } else {
      delete params.partner_company_branch_id;
    }
    this.setState({
      params,
      tempParams,
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
      userSelected: [],
      selectAll: false,
    });
  };

  /**
   * @description CSV出力準備
   */
  csvDownloadPreparation = async () => {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    const params = this.changeSortParams(_.cloneDeep(this.state.params));
    isPrimaryCompanyRoleId(this.roleId)
      ? await csvDownloader('api/private/users/list.csv', params)
      : await csvDownloader('api/private/users/partner_list.csv', params);
    this.isDownloadingFlag = false;
  };

  /**
   * @description サービス権限一括変更ダイアログ表示
   * （3末以降のマイルストーンで利用するようになる）
   */
  onDisplayChangePermitDialog = () => {
    const params = { ...this.state.params };
    dialogLoader.show(ChangePermitDialog, {
      // ForemanNewPasswordDialog側でthis.props.dialog.paramsで取得できる
      params: {
        searchParams: params,
      },
      callback: {
        back: () => {
          this.searchExecution();
          dialogLoader.close();
        },
      },
    });
  };

  // 3末以降のマイルストーンで利用予定
  moveBuildeeManagerRequest = () => {
    const isActiveManagerRequestButton = _.cloneDeep(
      this.state.isActiveManagerRequestButton
    );
    if (isActiveManagerRequestButton === false) {
      this.showBuildeeManagerApplyingMessage();
    } else {
      _masterSlideLoader.show('BuildeeManagerRequest', {
        state: {},
      });
    }
  };

  /**
   * エラーダイアログを閉じる
   */
  closeErrorDialog = () => {
    this.setState({
      errorDialogFlg: false,
      errorMessage: '',
    });
  };

  /**
   * ソート用パラメータ切り替え
   */
  changeSortParams = params => {
    delete params.sort_company_name;
    delete params.sort_branch_name;
    delete params.sort_fullname;
    delete params.sort_fullname_kana;
    delete params.sort_user_role_code;
    delete params.sort_partner_branch_company;
    switch (params.order) {
      case 'company_asc':
        params.sort_company_name = 'asc';
        delete params.order;
        break;
      case 'company_desc':
        params.sort_company_name = 'desc';
        delete params.order;
        break;
      case 'branch_asc':
        params.sort_branch_name = 'asc';
        delete params.order;
        break;
      case 'branch_desc':
        params.sort_branch_name = 'desc';
        delete params.order;
        break;
      case 'fullname_asc':
        params.sort_fullname = 'asc';
        delete params.order;
        break;
      case 'fullname_desc':
        params.sort_fullname = 'desc';
        delete params.order;
        break;
      case 'fullname_kana_asc':
        params.sort_fullname_kana = 'asc';
        delete params.order;
        break;
      case 'fullname_kana_desc':
        params.sort_fullname_kana = 'desc';
        delete params.order;
        break;
      case 'user_role_code_asc':
        params.sort_user_role_code = 'asc';
        delete params.order;
        break;
      case 'user_role_code_desc':
        params.sort_user_role_code = 'desc';
        delete params.order;
        break;
      case 'partner_company_branch_name_asc':
        params.sort_partner_company_branch_name = 'asc';
        delete params.order;
        break;
      case 'partner_company_branch_name_desc':
        params.sort_partner_company_branch_name = 'desc';
        delete params.order;
        break;
    }
    return params;
  };

  /**
   * 企業管理者申請中のメッセージを表示する
   */
  showBuildeeManagerApplyingMessage = () => {
    this.setState({ buildeeManagerMessageFlg: true });
  };

  /**
   * 企業管理者申請中のメッセージを閉じる
   */
  closeBuildeeManagerApplyingMessage = () => {
    this.setState({ buildeeManagerMessageFlg: false });
  };

  handleSelectPartnerCompanyBranch = partnerCompanyBranchId => {
    const { tempParams } = this.state;
    this.setState({
      partnerCompanyBranchId,
      tempParams: {
        ...tempParams,
        partner_company_branch_id: partnerCompanyBranchId,
      },
    });
  };

  handleSelectAll = (checked, users) => {
    this.setState({
      selectAll: checked,
      userSelected: checked ? users : [],
    });
  };

  handleSelectUser = (checked, user) => {
    let userSelected = _.cloneDeep(this.state.userSelected);
    if (checked) {
      userSelected = [...userSelected, user];
    } else {
      userSelected = _.filter(userSelected, item => item.id !== user.id);
    }
    this.setState({ userSelected });
  };

  toggleDialog = dialogType => {
    const prevDialogType = this.state.dialogType;
    if (prevDialogType === ENUM_DIALOG.updateSuccess) {
      this.handleClearParam();
    }
    this.setState({ dialogType });
  };

  handleClearParam = () => {
    if (this.searchingFlag) {
      return;
    }
    this.searchingFlag = true;
    _.each(document.querySelectorAll('.search-form__body input'), input => {
      input.value = null;
      input.checked = null;
    });

    this.setState({
      params: _.cloneDeep(this.defaultParams),
      tempParams: {
        offset: 0,
        limit: REQUEST_PARAMS.parentLimit,
        company_id: SessionStorageService.getCompanyId(),
        order: '',
        company_branch_id: null, // 支店ID検索
        fullname: null, // 氏名検索
        user_id: null, // ユーザーID、メールアドレス検索
        user_role_code: [], // 種別(ロール)検索
        buildee_manager_flg: null, // 企業管理者検索
        block_flag: [], // ステータス検索
      },
      searchParam: {
        company_branch_id: null,
        name: '',
        clearFlag: true,
      },
      isFetch: true,
      isLoading: true,
      isNewSearch: true,
      partnerCompanyBranchId: null,
      userSelected: [],
      selectAll: false,
    });
  };

  handleUpdatePartnerCompanyBranch = () => {
    const { userSelected } = this.state;
    if (_.isEmpty(userSelected)) {
      return this.setState(
        {
          dialogInfo: {
            title: 'ユーザーが選択されていません',
            message:
              '変更対象となるユーザーが選択されていません。支店を変更するユーザーを選択してください。',
          },
        },
        () => {
          this.toggleDialog(ENUM_DIALOG.noSelectUser);
        }
      );
    }
    this.toggleDialog(ENUM_DIALOG.updatePartnerCompanyBranch);
  };

  handleSubmitUpdatePartnerCompany = async partnerCompanyBranchId => {
    if (this.isUpdatingFlag) {
      return;
    }
    this.isUpdatingFlag = true;
    const userSelected = _.cloneDeep(this.state.userSelected);
    const userIds = _.map(userSelected, user => user.id);
    let dialogType;
    let updateDialog = true;
    const dialogInfo = {
      title: '支店の一括変更完了',
      message: '支店の一括変更が完了しました。',
    };
    try {
      await UsersApi.bulkUpdatePartnerCompanyBranch(
        {
          user_ids: userIds,
          company_id: this.companyId,
          partner_company_branch_id: partnerCompanyBranchId,
        },
        false
      );
      dialogType = ENUM_DIALOG.updateSuccess;
    } catch (e) {
      if (e.status === 404 || e.status === 403) {
        updateDialog = false;
        return window.location.replace('/error-permission');
      }
      dialogType = ENUM_DIALOG.updateError;
      dialogInfo.title = '更新に失敗しました';
      dialogInfo.message =
        _.get(e, 'data.message') ||
        'エラーが発生しました。再度操作を行ってください。';
    } finally {
      this.isUpdatingFlag = false;
      if (updateDialog) {
        this.setState(
          {
            dialogInfo,
          },
          () => this.toggleDialog(dialogType)
        );
      }
    }
  };

  setVisibleDownloadErrorDialog = bool => {
    this.setState({
      visibleDownloadErrorDialog: bool,
    });
  };

  /**
   * Handle download file manual user
   */
  downloadUserManual = async () => {
    if (this.isDownloadingFlag) {
      return;
    }
    this.isDownloadingFlag = true;
    await PrintUtility.downloadStaticFilePDF(
      CORPORATE_ADMINISTRATOR_MANUAL.fileCode,
      CORPORATE_ADMINISTRATOR_MANUAL.fileName,
      this.setVisibleDownloadErrorDialog
    );
    this.isDownloadingFlag = false;
  };

  render() {
    let {
      params,
      search_form_open,
      isFetch,
      isLoading,
      isNewSearch,
      isViewManagerRequestButton,
      isActiveManagerRequestButton,
      isActiveChangePermissionButton,
      partnerCompanyBranchId,
      dialogType,
    } = this.state;
    const isActiveUpdatePartnerCompanyBranchButton = !!(
      this.state.isBuildeeManager && this.partnerCompanyJoiningFlag
    );

    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - ユーザー一覧</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={'ユーザー一覧'}
            onClose={() => _masterSlideLoader.close()}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <HeaderMenu
              roleId={this.roleId}
              onCsvDownloadPreparation={this.csvDownloadPreparation}
              onDisplayChangePermitDialog={this.onDisplayChangePermitDialog}
              moveBuildeeManagerRequest={this.moveBuildeeManagerRequest}
              companyBranchId={this.companyBranchId}
              isViewManagerRequestButton={isViewManagerRequestButton}
              isActiveManagerRequestButton={isActiveManagerRequestButton}
              isActiveChangePermissionButton={isActiveChangePermissionButton}
              handleUpdatePartnerCompanyBranch={
                this.handleUpdatePartnerCompanyBranch
              }
              isActiveUpdatePartnerCompanyBranchButton={
                isActiveUpdatePartnerCompanyBranchButton
              }
            />
            <SearchForm
              onOpen={() =>
                this.setState({
                  search_form_open: !search_form_open,
                })
              }
              onSearchExecution={this.searchExecution}
              searchButtonRef={this.searchButtonRef}
              isOpen={search_form_open}
              total={this.total}
              roleId={this.roleId}
              tempParams={this.state.tempParams}
              searchParam={this.state.searchParam}
              events={this.events}
              clearParams={this.handleClearParam}
              selectedCompanyId={this.companyId}
              selectedPartnerCompanyBranchId={partnerCompanyBranchId}
              partnerCompanyBranchId={partnerCompanyBranchId}
              onSelect={this.handleSelectPartnerCompanyBranch}
              partnerCompanyJoiningFlag={this.partnerCompanyJoiningFlag}
            />
            <div className={Styles.buildee_manager_info}>
              企業管理者は種別欄に
              <BuildeeManagerIcon
                className={`icon--2x ${Styles.buildee_manager_icon}`}
              />
              が表示されます。
              <span
                className='clickable-text'
                onClick={this.downloadUserManual}
                data-testid='corporate_administrator_manual_download_link'
              >
                企業管理者説明資料のダウンロード
              </span>
            </div>
            <div className='master-slide-view__body'>
              <div className='constructionlist__list'>
                <Table
                  parentId='infinityscroll-target'
                  onLoad={this.userItemLoad}
                  header={({ list_data }) => (
                    <TableHeader
                      dataList={list_data}
                      order={_.defaultTo(params.order, '')}
                      partnerCompanyJoiningFlag={this.partnerCompanyJoiningFlag}
                      handleSelectAll={this.handleSelectAll}
                      selected={this.state.selectAll}
                      isActiveUpdatePartnerCompanyBranchButton={
                        isActiveUpdatePartnerCompanyBranchButton
                      }
                      isLoading={isLoading}
                    />
                  )}
                  body={props => (
                    <TableItem
                      {...props}
                      partnerCompanyJoiningFlag={this.partnerCompanyJoiningFlag}
                      handleSelectUser={this.handleSelectUser}
                      selectAll={this.state.selectAll}
                      isActiveUpdatePartnerCompanyBranchButton={
                        isActiveUpdatePartnerCompanyBranchButton
                      }
                    />
                  )}
                  isFetch={isFetch}
                  isLoading={isLoading}
                  isNewSearch={isNewSearch}
                />
              </div>
            </div>
            <Information
              message={this.state.errorMessage}
              buttonText={messageUtility.getMessage('I-000-017')}
              visible={this.state.errorDialogFlg}
              onClose={() => this.closeErrorDialog()}
            />
            <Information
              visible={this.state.visibleDownloadErrorDialog}
              title='ダウンロードエラー'
              message={messageUtility.getMessage('E-000-033')}
              buttonText={messageUtility.getMessage('I-000-017')}
              onClose={() => this.setVisibleDownloadErrorDialog(false)}
              buttonClassName='btn--sub'
            />
            <BuildeeManagerApplyingModal
              visible={this.state.buildeeManagerMessageFlg}
              buildeeManagerGrantRequest={this.state.buildeeManagerGrantRequest}
              onClose={() => this.closeBuildeeManagerApplyingMessage()}
            />
            <Information
              message={this.state.dialogInfo.message}
              title={this.state.dialogInfo.title}
              buttonText={messageUtility.getMessage('I-000-017')}
              visible={
                [
                  ENUM_DIALOG.noSelectUser,
                  ENUM_DIALOG.updateError,
                  ENUM_DIALOG.updateSuccess,
                ].indexOf(dialogType) !== -1
              }
              onClose={() => this.toggleDialog(null)}
              multilineText={true}
            />
            <UpdatePartnerCompanyBranchUsersDialog
              selectedCompanyId={this.companyId}
              visible={dialogType === ENUM_DIALOG.updatePartnerCompanyBranch}
              data={this.state.userSelected}
              onCancel={() => this.toggleDialog(null)}
              onConfirm={this.handleSubmitUpdatePartnerCompany}
            />
          </div>
        </div>
      </div>
    );
  }
}

/**
 * @description ヘッダーのソート関数
 * @param {String} key ソートするKey名
 * @param {String} order 前回のソート内容
 */
const onSort = (key, order) => {
  EventMg.trigger(
    MY_EVENT.SEARCH_FORM_CHANGE,
    order === `${key}_asc` ? `${key}_desc` : `${key}_asc`,
    'order',
    true
  );
};

/**
 * @description リスト一覧のヘッダー部分
 */
const TableHeader = ({
  order,
  partnerCompanyJoiningFlag,
  dataList,
  handleSelectAll,
  selected,
  isActiveUpdatePartnerCompanyBranchButton,
  isLoading,
}) => {
  const HeaderCell = ({ children, sortKey, isLabel = true }) => {
    const handleSort = () => {
      if (sortKey && !isLoading) {
        onSort(sortKey, order);
      }
    };

    return (
      <td
        className={`value-table ${
          isLabel ? 'value-table--table__label subpixel-fix' : ''
        }`}
      >
        <div
          className={isLabel ? 'value-table__label' : ''}
          onClick={handleSort}
        >
          {children}
          {sortKey && getSortButton(order, sortKey)}
        </div>
      </td>
    );
  };

  return (
    <thead className={`table__header ${Styles.table_user_header}`}>
      <tr className='table__label'>
        {isActiveUpdatePartnerCompanyBranchButton && (
          <HeaderCell>
            <div>
              <input
                type='checkbox'
                onClick={e => e.stopPropagation()}
                checked={selected}
                onChange={e => handleSelectAll(e.target.checked, dataList)}
              />
            </div>
          </HeaderCell>
        )}
        <UserTypeSwitchForm
          exc_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
        >
          <HeaderCell sortKey='branch'>支店名</HeaderCell>
        </UserTypeSwitchForm>
        {!!partnerCompanyJoiningFlag && (
          <UserTypeSwitchForm
            match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
          >
            <HeaderCell sortKey='partner_company_branch_name'>支店</HeaderCell>
          </UserTypeSwitchForm>
        )}
        <HeaderCell sortKey='fullname'>氏名</HeaderCell>
        <HeaderCell sortKey='email'>
          {isPrimaryCompanyRoleId(this.roleId)
            ? 'ユーザーID'
            : 'ユーザーID・メールアドレス'}
        </HeaderCell>
        <HeaderCell sortKey='user_role_code'>種別</HeaderCell>
        <HeaderCell>サービス権限</HeaderCell>
        <HeaderCell sortKey='created_at'>登録日</HeaderCell>
        <HeaderCell sortKey='updated_at'>更新日</HeaderCell>
        <HeaderCell />
      </tr>
    </thead>
  );
};

/**
 * Tooltipで表示される文字
 * @param {string} data 表示データ
 */
const renderTooltipContent = data => {
  const rowStyle = {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    maxWidth: '240px',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

/**
 * @description user item コンポーネント
 */
class TableItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canDrag: true,
      userSelected: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data.id !== this.props.data.id) {
      this.setState({ userSelected: false });
    }
    if (this.props.selectAll !== prevProps.selectAll) {
      this.setState({ userSelected: this.props.selectAll });
    }
  }

  onEndDrag(drop_result, props, monitor, component) {
    this.setState({ canDrag: false });
    if (this.props.onEndDrag) {
      return this.props.onEndDrag(drop_result, props, monitor, component);
    }
  }

  onDropped(dropProps, monitor, dropComponent) {
    if (this.props.onDropped) {
      return this.props.onDropped(dropProps, monitor, dropComponent);
    }
  }

  onBeginDrag(props, monitor, component) {
    if (this.props.onBeginDrag) {
      return this.props.onBeginDrag(props, monitor, component);
    }
  }

  /**
   * @description ドラッグ＆ドロップできるようにラップする
   * @param {React.ReactElement} elements
   */
  setWrapperDnd(elements) {
    if (this.props.canDrag) {
      return (
        <DragSourceAndDropTarget
          id={this.props.id}
          onDropped={this.onDropped.bind(this)}
          onBeginDrag={this.onBeginDrag.bind(this)}
          onEndDrag={this.onEndDrag.bind(this)}
          canDrag={this.state.canDrag}
        >
          {elements}
        </DragSourceAndDropTarget>
      );
    }

    return elements;
  }

  getStatusTag = flag => {
    const tags = {
      [USER_STATUS.use.id]: <div />,
      [USER_STATUS.stop.id]: (
        <div className='status--long--caution'>停止中</div>
      ),
    };
    return tags[flag] || <div />;
  };

  getSelected = userId => {
    return _.some(this.state.userSelected, ['id', userId]);
  };

  handleOnChange = (checked, userId) => {
    this.setState({ userSelected: checked });
    this.props.handleSelectUser(checked, userId);
  };

  render() {
    const {
      data,
      partnerCompanyJoiningFlag,
      isActiveUpdatePartnerCompanyBranchButton,
    } = this.props;
    const branch_name =
      data.user_role_code === USER_ROLES.prime.id
        ? '本社'
        : _.get(data, 'company_branch.name', '');

    return this.setWrapperDnd(
      <tr
        className={`table__item ${
          data.block_flag === USER_STATUS.stop.id
            ? ' value-table--suspension'
            : ''
        }`}
      >
        {isActiveUpdatePartnerCompanyBranchButton && (
          <td className='value-table'>
            <div>
              <input
                type='checkbox'
                onClick={e => e.stopPropagation()}
                checked={this.state.userSelected}
                onChange={e => this.handleOnChange(e.target.checked, data)}
              />
            </div>
          </td>
        )}
        <UserTypeSwitchForm
          exc_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
        >
          <td className='value-table construction-list-value-table__branch-name'>
            <span className='label'>支店名</span>
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              role={`tippy_target_${_.uniqueId()}`}
              html={renderTooltipContent(branch_name)}
            >
              <div className='value-table__txt--7'>{branch_name}</div>
            </Tippy>
          </td>
        </UserTypeSwitchForm>

        {!!partnerCompanyJoiningFlag && (
          <UserTypeSwitchForm
            match_id={[USER_ROLES.partner.id, USER_ROLES.foreman.id]}
          >
            <td className='value-table construction-list-value-table__branch-name'>
              <span className='label'>支店名</span>
              <Tippy
                duration={10}
                distance={24}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                role={`tippy_target_${_.uniqueId()}`}
                html={renderTooltipContent(
                  _.get(
                    data,
                    'partner_company_branch.name',
                    HEAD_OFFICE_OPTION.name
                  )
                )}
              >
                <div className='value-table__txt--7'>
                  {_.get(
                    data,
                    'partner_company_branch.name',
                    HEAD_OFFICE_OPTION.name
                  )}
                </div>
              </Tippy>
            </td>
          </UserTypeSwitchForm>
        )}

        <td className='value-table construction-list-value-table__name'>
          <span className='label'>氏名</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${_.uniqueId()}`}
            html={renderTooltipContent(_.defaultTo(data.fullname_kana, ''))}
          >
            <div className='value-table__fullname_kana'>
              {_.defaultTo(data.fullname_kana, '')}
            </div>
          </Tippy>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${_.uniqueId()}`}
            html={renderTooltipContent(_.defaultTo(data.fullname, ''))}
          >
            <div className='value-table__txt--7'>
              {_.defaultTo(data.fullname, '')}
            </div>
          </Tippy>
        </td>

        <td className='value-table construction-list-value-table__name'>
          <span className='label'>ユーザーID・メールアドレス</span>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${data.login_id}`}
            html={renderTooltipContent(_.defaultTo(data.login_id, ''))}
          >
            {isForemanRoleId(data.user_role_code) ? (
              <div className='value-table__txt--10 text-1line text-color-grey'>
                <span className='value-table__user-id-black'>ユーザID：</span>
                {_.defaultTo(data.login_id, '')}
              </div>
            ) : (
              <div className='value-table__txt--10 text-1line'>
                {_.defaultTo(data.login_id, '')}
              </div>
            )}
          </Tippy>
          {isForemanRoleId(data.user_role_code) && data.email && (
            <Tippy
              duration={10}
              distance={24}
              arrowType='sharp'
              delay={[500, 0]}
              placement='bottom'
              followCursor={true}
              role={`tippy_target_${data.email}`}
              html={renderTooltipContent(_.defaultTo(data.email))}
            >
              <div className='value-table__txt--10 text-1line'>
                アドレス：{_.defaultTo(data.email ? data.email : '登録なし')}
              </div>
            </Tippy>
          )}
          {isForemanRoleId(data.user_role_code) && !data.email && (
            <div className='value-table__txt--10 text-1line'>
              アドレス：{_.defaultTo(data.email ? data.email : '登録なし')}
            </div>
          )}
        </td>

        <td className='value-table construction-list-value-table__address'>
          <span className='label'>種別</span>
          <div className='value-table__txt--10'>
            <span
              className={`${!data.permissions.buildee_manager_flg &&
                Styles.buildee_manager_icon_hidden_area}`}
            >
              <Tippy
                duration={10}
                distance={24}
                arrow={true}
                arrowType='sharp'
                delay={[500, 0]}
                placement='bottom'
                followCursor={true}
                html={renderTooltipContent(
                  messageUtility.getMessage('I-000-111')
                )}
              >
                <BuildeeManagerIcon
                  className={`icon--2x ${Styles.buildee_manager_icon} ${!data
                    .permissions.buildee_manager_flg &&
                    Styles.buildee_manager_icon_hidden}`}
                />
              </Tippy>
            </span>
            {getRoleNameByRoleId(data.user_role_code)}
          </div>
        </td>
        <td className='value-table construction-list-value-table__address'>
          <span className='label'>サービス権限</span>

          <div className='value-table__txt--10'>
            <ServiceIcons
              permissions={data.permissions}
              blockFlag={data.block_flag}
            />
          </div>
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>登録日</span>
          <div className='value-table__date'>{data.created_at || ''}</div>
        </td>
        <td className='value-table construction-list-value-table__date'>
          <span className='label'>更新日</span>
          <div className='value-table__date'>{data.updated_at || ''}</div>
        </td>

        <td className='value-table construction-list-value-table__edit'>
          <div className='value-table__normal'>
            <button
              className='btn--sm--stay'
              onClick={() => EventMg.trigger(MY_EVENT.CHANGE_FORM_SHOW, data)}
            >
              確認
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

/**
 * "職長の初期パスワードを再発行"のダイアログを表示
 *
 */
const showDialog = companyBranchId => {
  dialogLoader.show(ForemanNewPasswordDialog, {
    // ForemanNewPasswordDialog側でthis.props.dialog.paramsで取得できる
    params: {
      // param :company_branch_id, :number, desc: "支店ID"
      companyBranchId,
      // 自社一覧タイプ
      dialogType: DialogType.USERS_LIST,
    },
    callback: {
      back: () => {
        dialogLoader.close();
      },
      submit: () => {
        dialogLoader.close();
      },
    },
  });
};

/**
 * 自社ユーザー一覧画面のヘッダ部分
 *
 * @param {*} { roleId, onCsvDownloadPreparation }
 */
const HeaderMenu = ({
  roleId,
  onCsvDownloadPreparation,
  onDisplayChangePermitDialog,
  moveBuildeeManagerRequest,
  companyBranchId,
  isActiveManagerRequestButton,
  isViewManagerRequestButton,
  isActiveChangePermissionButton,
  handleUpdatePartnerCompanyBranch,
  isActiveUpdatePartnerCompanyBranchButton,
}) => (
  <div className='master-slide-view__menu'>
    <ul className='btn-menu'>
      <li className='btn-menu__item'>
        <PrimeContractorToPartnerButton
          label={'新規作成'}
          buttonClass={'btn'}
          onClick={() => {
            _masterSlideLoader.show('UserNew', { state: { id: 1 } });
          }}
        />
      </li>
    </ul>
    <ul className='btn-menu' style={{ flexDirection: 'row-reverse' }}>
      <li className='btn-menu__item'>
        {isViewManagerRequestButton && (
          <button
            className={isActiveManagerRequestButton ? 'btn' : 'btn--sub'}
            onClick={moveBuildeeManagerRequest}
          >
            企業管理者申請
          </button>
        )}
      </li>
      {isActiveChangePermissionButton && (
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={renderTooltipContent(messageUtility.getMessage('I-000-105'))}
          disable={isActiveChangePermissionButton}
        >
          <li className='btn-menu__item'>
            <button
              className={
                isActiveChangePermissionButton ? 'btn--sub' : 'btn--disabled'
              }
              disabled={!isActiveChangePermissionButton}
              onClick={onDisplayChangePermitDialog}
            >
              サービス権限の一括変更
            </button>
          </li>
        </Tippy>
      )}
      {isTargetRoleId(
        [
          USER_ROLES.prime,
          USER_ROLES.branch,
          USER_ROLES.manager,
          USER_ROLES.partner,
        ],
        roleId
      ) && (
        <li className='btn-menu__item'>
          <button className='btn--sub' onClick={onCsvDownloadPreparation}>
            表示データをCSV出力
          </button>
        </li>
      )}
      <li className='btn-menu__item'>
        {/* ダイアログが出る */}
        {/* 権限：実行できるは協力会社管理者 */}
        <button
          className='btn--sub'
          style={roleId === 5 ? { display: 'block' } : { display: 'none' }}
          onClick={() => {
            showDialog(companyBranchId);
          }}
        >
          {messageUtility.getMessage('I-001-004')}
        </button>
      </li>
    </ul>
    {isActiveUpdatePartnerCompanyBranchButton && (
      <ul className='btn-menu'>
        <li className='btn-menu__item'>
          <button
            className='btn--sub'
            onClick={handleUpdatePartnerCompanyBranch}
          >
            支店の一括変更
          </button>
        </li>
      </ul>
    )}
  </div>
);

const SearchFormHeader = ({ onOpen, isOpen, total, clearParams }) => (
  <div className='search-form__header'>
    <div className='search-form__title'>
      検索条件（検索結果
      <span className='bold'>{total}</span>
      件）
    </div>
    <button
      id='accordion-toggle'
      className={isOpen ? 'accordion__btn show' : 'accordion__btn'}
      onClick={onOpen}
    />
    <button className='btn-text--sm' onClick={clearParams}>
      検索条件クリア
    </button>
  </div>
);

/**
 * 種別検索フォーム
 * @param {number}currentRoleId 操作ユーザーのロールID
 * @param {array}currentRoleCodes 設定されているロール検索条件
 */
const SearchFormRoles = ({ currentRoleId, currentSearchRoleCodes }) => {
  let targetRoles = [];
  if (isPrimaryCompanyRoleId(currentRoleId)) {
    targetRoles = [USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager];
  } else {
    targetRoles = [USER_ROLES.partner, USER_ROLES.foreman];
  }
  return (
    <ul className='search-form__checklist_sub'>
      {targetRoles.map(role => {
        return (
          <li key={role.key}>
            <label className='checkbox' key={`checkbox-${role.key}`}>
              <input
                type='checkbox'
                name={role.name}
                checked={currentSearchRoleCodes.includes(role.id)}
                onClick={() => {
                  EventMg.trigger(
                    MY_EVENT.SEARCH_FORM_CHANGE,
                    role.id,
                    'user_role_code',
                    false
                  );
                }}
                readOnly
              />
              <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
              <span className='radio-search-span'>{role.name}</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
};

/**
 * 企業管理者検索フォーム
 */
const SearchFormManager = ({ managerFlag }) => (
  <ul className='search-form__checklist_sub'>
    <li>
      <label className='checkbox' key={`checkbox-manager`}>
        <input
          type='checkbox'
          name={'checkbox-manager'}
          checked={managerFlag}
          onClick={() => {
            EventMg.trigger(
              MY_EVENT.SEARCH_FORM_CHANGE,
              null,
              'buildee_manager_flg',
              false
            );
          }}
          readOnly
        />
        <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
        <BuildeeManagerIcon
          className={`icon--2x ${Styles.buildee_manager_icon}`}
        />
        <span className='radio-search-span'>企業管理者のみを表示する</span>
      </label>
    </li>
  </ul>
);

/**
 * ステータス検索フォーム
 */
const SearchFormStatus = ({ currentSearchStatus }) => (
  <ul className='search-form__checklist_sub'>
    {_.map(USER_STATUS, status => {
      return (
        <li key={`status-id-${status.id}`}>
          <label className='checkbox' key={`checkbox-${status.id}`}>
            <input
              type='checkbox'
              name={'checkbox-${status.id}'}
              checked={currentSearchStatus.includes(status.id)}
              onClick={() => {
                EventMg.trigger(
                  MY_EVENT.SEARCH_FORM_CHANGE,
                  status.id,
                  'block_flag'
                );
              }}
              readOnly
            />
            <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
            <span className='radio-search-span'>{status.name}</span>
          </label>
        </li>
      );
    })}
  </ul>
);

const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);

const SearchForm = ({
  onOpen,
  onSearchExecution,
  searchButtonRef,
  isOpen,
  total,
  searchParam,
  tempParams, // 検索条件
  events,
  clearParams,
  selectedCompanyId,
  selectedPartnerCompanyBranchId,
  partnerCompanyJoiningFlag,
  onSelect,
  roleId,
}) => (
  <div className='master-slide-view__searchform_no_border'>
    <div className='search-form'>
      <SearchFormHeader
        onOpen={onOpen}
        isOpen={isOpen}
        total={total}
        clearParams={clearParams}
      />
      <div
        id='search-form-accordion'
        className={isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body set-width-dropdown'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              {/* 支店名検索 */}
              <SearchFormElement
                label='支店名'
                eleClass='form-element__element'
              >
                {isPrimaryCompanyRoleId(roleId) && (
                  // 元請けユーザーの場合
                  <CompanyBranchDropdown
                    name='company_branch_id'
                    value={tempParams.company_branch_id}
                    set={(setkey, selected) =>
                      events.form.dropdownParam(setkey, selected)
                    }
                    setkey='company_branch_id'
                    clearFlag={searchParam.clearFlag}
                    isOptional={true}
                  />
                )}
                {isPartnerCompanyRoleId(roleId) && (
                  // 協力会社ユーザーの場合
                  <PartnerCompanyBranchDropdown
                    selectedCompanyId={selectedCompanyId}
                    selectedPartnerCompanyBranchId={
                      selectedPartnerCompanyBranchId
                    }
                    onSelect={onSelect}
                    isOptional={true}
                    fixedOptions={[HEAD_OFFICE_OPTION]}
                    dropdownSelectStyle={{ width: '190px' }}
                  />
                )}
              </SearchFormElement>
              {/* 氏名検索 */}
              <SearchFormElement
                label='氏名(ふりがな検索可)'
                eleClass='form-element__element'
              >
                <input
                  type='text'
                  onBlur={e => {
                    EventMg.trigger(
                      MY_EVENT.SEARCH_FORM_CHANGE,
                      e.target.value,
                      'fullname',
                      false
                    );
                  }}
                  placeholder='氏名・ふりがなを入力'
                  className=''
                />
              </SearchFormElement>
              {/* ユーザーID検索 */}
              <SearchFormElement
                label={
                  isPrimaryCompanyRoleId(roleId)
                    ? 'ユーザーID'
                    : 'ユーザーID・メールアドレス'
                }
                eleClass='form-element__element'
              >
                <input
                  type='text'
                  onBlur={e => {
                    EventMg.trigger(
                      MY_EVENT.SEARCH_FORM_CHANGE,
                      e.target.value,
                      'user_id',
                      false
                    );
                  }}
                  placeholder='kensetsu@buildee.jp'
                  className=''
                />
              </SearchFormElement>
              {/* 種別検索 */}
              <SearchFormElement label='種別' eleClass='form-element__element'>
                <SearchFormRoles
                  currentRoleId={roleId}
                  currentSearchRoleCodes={tempParams.user_role_code}
                />
              </SearchFormElement>
              {/* 企業管理者検索 ラベル名は無だが配列調整のため空白を挿入 */}
              <SearchFormElement label='　' eleClass='form-element__element'>
                <SearchFormManager
                  managerFlag={tempParams.buildee_manager_flg}
                />
              </SearchFormElement>
              {/* ステータス検索 */}
              <SearchFormElement
                label='ステータス'
                eleClass='form-element__element'
              >
                <SearchFormStatus currentSearchStatus={tempParams.block_flag} />
              </SearchFormElement>
              <SearchFormElement>
                <button
                  className='btn--sm--stay search-form__btn__users'
                  onClick={onSearchExecution}
                  ref={searchButtonRef}
                >
                  検索
                </button>
              </SearchFormElement>
            </div>
            <div className='search-form__info'>
              <div className='search-form__info-text'>
                検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/**
 * @description サービスのアイコン設定
 * ユーザーが停止中の場合には停止ラベルを表示し
 * 利用中の場合には権限を持つサービスのアイコンを表示する
 * @param {object} permissions サービス権限
 * @param {boolean} blockFlag ユーザーが停止中かどうか
 */

const ServiceIcons = ({ permissions, blockFlag }) => {
  if (blockFlag) {
    return <div className='status--long--suspension'>停止中</div>;
  }
  let icons = [];
  // 調整会議
  if (permissions.use_chosei_flg) {
    icons.push(<div className='option-icon-chosei' />);
  } else {
    icons.push(<div className='option-icon-empty' />);
  }
  // 入退場
  if (permissions.use_nyutaijo_flg) {
    icons.push(<div className='option-icon-entrance' />);
  } else {
    icons.push(<div className='option-icon-empty' />);
  }
  // 労務安全
  if (permissions.use_green_file_flg) {
    icons.push(<div className='option-icon-greenfile' />);
  } else {
    icons.push(<div className='option-icon-empty' />);
  }
  return _.map(icons, (icon, i) => (
    <span key={`value-table__content-no.${i}`} className='value-table__content'>
      {icon}
    </span>
  ));
};

/**
 * サービス権限一括変更ダイアログのクラス
 */
class ChangePermitDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      checkAll: false,
      isLoaded: false,
      errorDialogFlg: false,
      errorMessage: '',
      completeDialogFlg: false,
      completeMessage: '',
    };
    this.params = this.props.dialog.params;
    this.changeServiceInfo = this.changeServiceInfo.bind(this);
  }

  componentDidMount() {
    this.loadUser();
  }

  /**
   * @description 一覧全選択のイベント
   */
  checkAllCheckbox() {
    if (this.state.users) {
      let paramUsers = _.cloneDeep(this.state.users);
      paramUsers = _.map(paramUsers, user => {
        user['checked'] = !this.state.checkAll;
        return user;
      });

      this.setState({ users: paramUsers, checkAll: !this.state.checkAll });
    }
  }

  /**
   * @description エラーダイアログを閉じる
   */
  closeErrorDialog = () => {
    let state = { ...this.state };
    state.errorDialogFlg = false;
    state.errorMessage = '';
    this.setState(state);
  };

  /**
   * @description 完了ダイアログを閉じる
   */
  closeCompleteDialog = () => {
    let state = { ...this.state };
    state.completeDialogFlg = false;
    state.completeMessage = '';
    state.checkAll = false;
    state.users = [];
    this.setState(state, () => {
      this.loadUser();
    });
  };

  /**
   * チェックする処理
   *
   * @param {numbr} userId user_id
   * @param {boolean} checked チェックしたか
   */
  pushCheckedUsers(userId, checked) {
    // 既にチェックされた項目を非選択する場合、全て選択のフラグをオフセットする
    if (checked && this.state.checkAll) {
      this.setState({ checkAll: false });
    }

    // パラメータ用
    let paramUsers = _.cloneDeep(this.state.users);
    paramUsers = _.map(paramUsers, user => {
      if (user.id === userId) {
        user['checked'] = !checked;
      }

      return user;
    });

    this.setState({ users: paramUsers });
  }

  /**
   * @description 一覧情報を表示
   */
  userComponent() {
    return _.map(this.state.users, (user, index) => {
      return (
        <UserRow
          key={`user_row_${user.user_id}_${index}`}
          data={user}
          callback={this.pushCheckedUsers.bind(this)}
        />
      );
    });
  }

  /**
   * @description ユーザー情報一覧をロードする
   */
  async loadUser(notify) {
    const state = { ...this.state };

    if (state.isLoaded && notify) {
      notify();
      return;
    }
    let params = this.params.searchParams;

    if (_.isArray(state.users)) {
      params.offset = state.users.length;
    } else {
      params.offset = 0;
    }

    const sessionPrimeCompanyId = SessionStorageService.getItem(
      'sessionPrimeCompanyId'
    );

    if (isLoginUserPartner() && sessionPrimeCompanyId) {
      params.prime_company_id = sessionPrimeCompanyId;
    }

    const res = await fetchMg
      .GetAjax('/api/private/users/list', params)
      .catch(() => ({ result: false }));

    const user_list = res.data.entities.user_lists;

    // ユーザデータのロードが完了するかどうか
    if (user_list.length === 0) {
      state.isLoaded = true;
    }

    state.users = state.users.concat(res.data.entities.user_lists);
    if (this.state.checkAll) {
      let paramUsers = state.users;
      paramUsers = _.map(paramUsers, user => {
        user['checked'] = true;
        return user;
      });
      state.users = paramUsers;
    }
    this.setState(state);

    if (notify) {
      notify();
    }
  }

  /**
   * @description サービス権限を変更
   * @param {object} permissions サービス権限
   * @param {object} completeMessage 完了メッセージ
   */
  async changeServiceInfo(permissions, completeMessage) {
    let params = {};
    if (this.state.checkAll) {
      params.all_user_flg = true;
      params.params = _.cloneDeep(this.params.searchParams);
      if (!isNullOrUndefinedOrEmptyStr(params.params.buildee_manager_flg)) {
        params.params.buildee_manager_flg = String(
          params.params.buildee_manager_flg
        );
      }

      const sessionPrimeCompanyId = SessionStorageService.getItem(
        'sessionPrimeCompanyId'
      );

      if (isLoginUserPartner() && sessionPrimeCompanyId) {
        params.params.prime_company_id = sessionPrimeCompanyId;
      }
    } else {
      let paramUsers = this.state.users;
      const userIds = [];
      _.map(paramUsers, user => {
        if (user.checked === true) {
          userIds.push(user.id);
        }
      });
      params.all_user_flg = false;
      params.user_ids = userIds;

      if (userIds.length === 0) {
        const state = { ...this.state };
        state.errorDialogFlg = true;
        state.errorMessage = messageUtility.getMessage('E-000-047');
        this.setState(state);
        return;
      }
    }
    params.update_params = {};
    params.update_params.permissions = permissions;

    try {
      const res = await UsersApi.updateServicePermissions(params);

      if (res.result === true) {
        const state = { ...this.state };
        state.completeMessage = completeMessage;
        state.completeDialogFlg = true;
        state.isLoaded = false;
        this.setState(state);
      } else {
        let errorMessage = '';
        if (res.message) {
          errorMessage = res.message;
        } else {
          errorMessage = res.data.message;
        }
        this.setState({ errorDialogFlg: true, errorMessage, isLoaded: false });
      }
    } catch (error) {
      let errorMessage = '';
      if (error.message) {
        errorMessage = error.message;
      } else {
        errorMessage = error.data.message;
      }
      this.setState({ errorDialogFlg: true, errorMessage, isLoaded: false });
    }
  }

  render() {
    return (
      <div className='dialog dialog--modal dialog--dialog-user-permissions'>
        <div className='dialog__header'>
          <span className='dialog__title'>サービス権限の一括変更</span>
        </div>
        <div className='dialog__introduction'>
          <p>
            選択したユーザーのサービス権限を一括で変更することができます。
            <br />
            ユーザーの検索を行う場合は、一度「閉じる」ボタンを押し、ユーザー一覧にて検索を行なった上で再度「サービス権限の一括変更」ボタンを押してください。
          </p>
        </div>
        <div className='dialog__body'>
          <div className='dual-panel'>
            <div className='dual-panel__item'>
              <div className='panel'>
                <div className='panel-header'>
                  <div className='panel-list change-permissions-table'>
                    <div className='top-table'>
                      <table className='table table--change-permissions-label'>
                        <thead className='table__header'>
                          <tr className='table__label'>
                            {/* チェックボックス */}
                            <th
                              className='value-table value-table--table__label'
                              style={{ width: '50px' }}
                            >
                              <label
                                htmlFor='checkbox-all'
                                className='checkbox'
                              >
                                <input
                                  className='checkbox-all'
                                  id='checkbox-all'
                                  type='checkbox'
                                  onClick={() => {
                                    this.checkAllCheckbox();
                                  }}
                                  checked={this.state.checkAll}
                                  onChange={() => {}}
                                />
                                <i className='i-square i-2_5x' />
                              </label>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>氏名</div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                ユーザーID
                              </div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>種別</div>
                            </th>
                            <th className='value-table value-table--table__label'>
                              <div className='value-table__name'>
                                サービス権限
                              </div>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div
                      className='change-permissions-table-element'
                      id='infinityscroll-target-dialog'
                    >
                      <table className='table'>
                        <tbody>{this.userComponent()}</tbody>
                      </table>
                      <InfinityScrollLoad
                        targetId={`infinityscroll-target-dialog`}
                        total={_.size(this.state.users)}
                        callback={notifyEnd => {
                          this.loadUser(notifyEnd);
                        }}
                      />
                    </div>
                  </div>
                  <div className='button-area'>
                    <div className='button-area-element button-area-element__chosei'>
                      <div className='button-area-element__title'>
                        <div className='option-icon-chosei button-area-element__icon' />
                        <div className='option-icon-entrance button-area-element__icon' />
                        調整会議・入退場の権限を変更
                      </div>
                      <div className='button-area-element__submit'>
                        <button
                          className='btn-fixedsize--effective'
                          onClick={() => {
                            this.changeServiceInfo(
                              {
                                use_chosei_flg: true,
                                use_nyutaijo_flg: true,
                              },
                              '調整会議・入退場'
                            );
                          }}
                        >
                          権限を付与
                        </button>
                        <button
                          className='btn-fixedsize--negative'
                          onClick={() => {
                            this.changeServiceInfo(
                              {
                                use_chosei_flg: false,
                                use_nyutaijo_flg: false,
                              },
                              '調整会議・入退場'
                            );
                          }}
                        >
                          権限を削除
                        </button>
                      </div>
                    </div>
                    <div className='button-area-element button-area-element__romu'>
                      <div className='button-area-element__title'>
                        <div className='option-icon-greenfile button-area-element__icon' />
                        労務安全の権限を変更
                      </div>
                      <div className='button-area-element__submit'>
                        <button
                          className='btn-fixedsize--effective'
                          onClick={() => {
                            this.changeServiceInfo(
                              {
                                use_green_file_flg: true,
                              },
                              '労務安全'
                            );
                          }}
                        >
                          権限を付与
                        </button>
                        <button
                          className='btn-fixedsize--negative'
                          onClick={() => {
                            this.changeServiceInfo(
                              {
                                use_green_file_flg: false,
                              },
                              '労務安全'
                            );
                          }}
                        >
                          権限を削除
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='dialog__footer'>
          <button
            className='btn-fixedsize--sub'
            onClick={() => {
              this.props.dialog.callback.back();
            }}
          >
            閉じる
          </button>
        </div>
        <Information
          message={this.state.errorMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.errorDialogFlg}
          onClose={() => this.closeErrorDialog()}
        />
        <Information
          title={messageUtility.getMessage('I-000-103')}
          message={messageUtility.getMessage(
            'I-000-104',
            this.state.completeMessage
          )}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.completeDialogFlg}
          onClose={() => this.closeCompleteDialog()}
        />
      </div>
    );
  }
}

const UserRow = props => {
  // チェックボックスのリファレンス
  const checkRef = React.createRef();
  const uid = `foreman_new_check_${_.uniqueId()}`;

  /**
   * @description チェックボックスの選択
   */
  const selectRow = (props, checkRef) => {
    if (_.isEmpty(checkRef.current)) {
      checkRef.current = {};
      checkRef.current.checked = false;
    }

    // チェックの反映
    if (props.callback) {
      // PushCheckedForeman()のこと
      props.callback(props.data.id, !!checkRef.current.checked);
    }
  };

  /**
   * @description ロール名を取得
   */
  const getRoleName = role_id => {
    for (let key in USER_ROLES) {
      if (role_id === USER_ROLES[key].id) {
        return USER_ROLES[key].name;
      }
    }
  };

  return (
    <tr
      onClick={() => {
        selectRow(props, checkRef);
      }}
      className='table__item editable'
      key={`foreman_new_${uid}`}
    >
      {/* チェックボックス */}
      <td className='value-table' style={{ width: '50px' }}>
        <div className='value-table__icon'>
          <div className='btn-checkbox-mini'>
            <label htmlFor={uid} className='checkbox'>
              <input
                id={uid}
                ref={checkRef}
                type='checkbox'
                name={props.data.id}
                checked={props.data.checked || false}
                onChange={() => {}}
              />
              <i className='i-square i-2_5x' />
            </label>
          </div>
        </div>
      </td>
      {/* 氏名 */}
      <td className='value-table'>
        <div className='value-table__name'>{props.data.fullname}</div>
      </td>
      {/* ユーザーID */}
      <td className='value-table'>
        <div className='value-table__name'>{props.data.login_id}</div>
      </td>
      {/* 種別 */}
      <td className='value-table'>
        <div className='value-table__name'>
          {getRoleName(props.data.user_role_code)}
        </div>
      </td>
      {/* サービス権限 */}
      <td className='value-table'>
        <div className='value-table__name'>
          <ServiceIcons permissions={props.data.permissions} />
        </div>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Users.jsx